import React from 'react'
import DashboardNav from '../Layout/DashboardNav'

function Help() {
    return (
        <div>
            <DashboardNav />
            Help Page

        </div>
    )
}

export default Help